import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
            <div className="pq-section pq-style-1 text-center">
              <span className="pq-section-sub-title">FAQs</span>
              <h2 className="pq-section-title">Frequently Asked Question</h2>
            </div>
            
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "What is vocal cord surgery and when is it needed?", answer: "Vocal cord surgery is a procedure done to treat problems like polyps, nodules, cysts, paralysis, or chronic hoarseness. It is recommended when voice therapy or medicines fail to improve the condition. The goal of the surgery is to restore normal voice quality, remove growths, and improve breathing or swallowing. Your ENT specialist will evaluate your symptoms and suggest the safest and most effective treatment." },
                  { question: "How is vocal cord surgery performed?", answer: "Most vocal cord surgeries are done endoscopically, meaning no external cuts are made. The surgeon uses a microscope or laser to remove growths or correct the vocal cord position through the mouth. The procedure is usually safe, takes 30–60 minutes, and patients go home the same day. Recovery includes voice rest and medications. Your ENT doctor decides the best technique based on the exact problem." },
                  { question: "What is the recovery time after vocal cord surgery?", answer: "Recovery is generally quick, but complete healing takes a few weeks. Patients are advised strict voice rest for a few days, followed by gradual use of voice. Mild throat discomfort or a change in voice is normal initially. Speech therapy is often recommended to regain proper voice function. Most people return to daily activities within 3–5 days, depending on the type of surgery and overall health." },
                  {question: "Is vocal cord surgery painful or risky?", answer: "Vocal cord surgery is usually painless because it is done under general anesthesia. After surgery, mild soreness or throat irritation can happen but improves quickly. Complications are rare and may include swelling, temporary voice change, or bleeding. Choosing an experienced ENT specialist significantly reduces risks. With proper post-care and therapy, most patients achieve excellent voice improvement."},
                  {question: "What is the cost of vocal cord surgery in Delhi, India?", answer: "The cost depends on the type of vocal cord condition, hospital setup, technology used, and whether laser or micro-surgery is needed. In Delhi, vocal cord surgery typically ranges from affordable to mid-range pricing compared to other metro cities. The ENT specialist provides an accurate estimate after evaluation. The cost usually includes consultation, tests, surgery, and follow-up care."}
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
